import classNames from 'classnames'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
import flatpickr, { Options as FlatpickrOptions } from 'flatpickr'
import { Polish } from 'flatpickr/dist/l10n/pl'
import React, { useEffect, useRef, useState } from 'react'

import { DateString } from '../../../api/services/orders/types.ts'
import { convertToShortDate } from '../../../utils/formatter.ts'

const Calendar = ({
  placeholder,
  defaultDate,
  setDate,
  minDate = undefined,
  maxDate = undefined,
  className
}: {
  placeholder: string
  defaultDate: string
  setDate: React.Dispatch<React.SetStateAction<string>>
  minDate?: string
  maxDate?: string
  className?: string
}) => {
  const [calendarDate, setCalendarDate] = useState(defaultDate)

  const validRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (validRef.current) {
      const options: FlatpickrOptions = {
        onChange: async (selectedDates: Date[]) => {
          setDate(convertToShortDate(selectedDates[0].toString()) as DateString)
          setCalendarDate(
            convertToShortDate(selectedDates[0].toString()) as DateString
          )
        },
        locale: Polish,
        mode: 'single',
        static: true,
        monthSelectorType: 'static',
        dateFormat: 'Y-m-d',
        minDate,
        maxDate,
        defaultDate: calendarDate,
        prevArrow:
          '<svg className="fill-current" width="7" height="11" viewBox="0 0 7 11"><path d="M5.4 10.8l1.4-1.4-4-4 4-4L5.4 0 0 5.4z" /></svg>',
        nextArrow:
          '<svg className="fill-current" width="7" height="11" viewBox="0 0 7 11"><path d="M1.4 10.8L0 9.4l4-4-4-4L1.4 0l5.4 5.4z" /></svg>'
      }

      flatpickr(validRef.current, options)
    }
  }, [validRef, calendarDate])

  return (
    <div>
      <input
        id="fromDate"
        name="fromDate"
        ref={validRef}
        className={classNames(
          className,
          'form-datepicker rounded border-[1.5px] px-5 py-3 font-normal outline-none transition',
          'border-stroke bg-transparent focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary'
        )}
        placeholder={placeholder}
        data-class="flatpickr-right"
        onChange={(e) => setCalendarDate(convertToShortDate(e.target.value))}
      />
    </div>
  )
}

export default Calendar
